import { gql } from '../__generated__';

export const MANAGED_COMPANIES_QUERY = gql(`
  query xcpManagedCompanies($first: Int, $after: String) {
    viewer {
      id
      managedCompanies(first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            company {
              ...CompanyData
            }
          }
        }
      }
    }
  }
`);
